import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/Details/Details.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/details/react/latest'} mdxType="DeprecationBanner" />
    <p><inlineCode parentName="p">{`Details`}</inlineCode>{` is a styled `}<inlineCode parentName="p">{`details`}</inlineCode>{` element for use with the `}<inlineCode parentName="p">{`useDetails`}</inlineCode>{` hook. The `}<inlineCode parentName="p">{`useDetails`}</inlineCode>{` hook returns the `}<inlineCode parentName="p">{`open`}</inlineCode>{` state, a `}<inlineCode parentName="p">{`setOpen`}</inlineCode>{` function to manually change the open state, and `}<strong parentName="p"><inlineCode parentName="strong">{`getDetailsProps`}</inlineCode>{` which must be spread onto your `}<inlineCode parentName="strong">{`Details`}</inlineCode>{` element in order for `}<inlineCode parentName="strong">{`Details`}</inlineCode>{` to get receive the proper behaviors provided by the hook`}</strong>{`. See `}<a parentName="p" {...{
        "href": "https://kentcdodds.com/blog/how-to-give-rendering-control-to-users-with-prop-getters"
      }}>{`Kent Dodd's article on this pattern`}</a>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`useDetails`}</inlineCode>{` hook also takes a few configuration options as parameters which are noted in the table below.`}</p>
    <p>{`You must use a `}<inlineCode parentName="p">{`summary`}</inlineCode>{` element as your `}<inlineCode parentName="p">{`Details`}</inlineCode>{` trigger button. To style your summary element like a `}<a parentName="p" {...{
        "href": "./Button"
      }}>{`Button`}</a>{`, you can use the `}<inlineCode parentName="p">{`as`}</inlineCode>{` prop (see example below).`}</p>
    <p>{`It's also possible to use the `}<inlineCode parentName="p">{`useDetails`}</inlineCode>{` hook with components other than the Primer `}<inlineCode parentName="p">{`Details`}</inlineCode>{`, such as a custom `}<inlineCode parentName="p">{`Details`}</inlineCode>{` or `}<inlineCode parentName="p">{`Modal`}</inlineCode>{` wrapper in your consuming application. All that matters is that the outer element is a `}<inlineCode parentName="p">{`details`}</inlineCode>{` and it contains a `}<inlineCode parentName="p">{`summary`}</inlineCode>{` for the button that opens and closes the component, and that `}<inlineCode parentName="p">{`getDetailsProps`}</inlineCode>{` is properly spread onto the component rendering your `}<inlineCode parentName="p">{`details`}</inlineCode>{` element.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State>
  {([]) => {
    const {getDetailsProps} = useDetails({closeOnOutsideClick: true})
    return (
      <Details {...getDetailsProps()}>
        <Button as="summary">Hello</Button>
        This is some content
      </Details>
    )
  }}
</State>
`}</code></pre>
    <p>{`You can use the `}<inlineCode parentName="p">{`open`}</inlineCode>{` state returned from the hook to conditionally render content:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State>
  {([]) => {
    const {getDetailsProps, open} = useDetails({closeOnOutsideClick: true})
    return (
      <Details {...getDetailsProps()}>
        <Button as="summary">{open ? 'open' : 'close'}</Button>
        This is some content
      </Details>
    )
  }}
</State>
`}</code></pre>
    <p>{`You can also manually show/hide the content using the `}<inlineCode parentName="p">{`setOpen`}</inlineCode>{` function returned from the hook. This can be useful if you have action items in the content of the component such as confirmation buttons:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State>
  {([]) => {
    const {getDetailsProps, setOpen} = useDetails({closeOnOutsideClick: true})
    return (
      <Details {...getDetailsProps()}>
        <Button as="summary">Delete item</Button>
        Are you sure?
        <Button variant="danger" onClick={() => setOpen(false)}>
          Yes I'm sure
        </Button>
      </Details>
    )
  }}
</State>
`}</code></pre>
    <p>{`In previous versions of Primer React Components, we allowed users to pass in a custom `}<inlineCode parentName="p">{`onToggle`}</inlineCode>{` function. You can do this now by overriding the `}<inlineCode parentName="p">{`onToggle`}</inlineCode>{` function returned in `}<inlineCode parentName="p">{`getDetailsProps`}</inlineCode>{`. Please note that in most cases, you'll want the hook's handling of `}<inlineCode parentName="p">{`onToggle`}</inlineCode>{` to be run as well, so that the internal state is properly updated. To do this, manually call the `}<inlineCode parentName="p">{`onToggle`}</inlineCode>{` handler returned from `}<inlineCode parentName="p">{`useDetails`}</inlineCode>{` before executing your custom `}<inlineCode parentName="p">{`onToggle`}</inlineCode>{` code.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State>
  {([]) => {
    const {getDetailsProps, open, setOpen} = useDetails({closeOnOutsideClick: true})
    const {onToggle, ...detailsProps} = getDetailsProps()
    const customToggle = e => {
      onToggle(e)
      window.alert('hi')
    }
    return (
      <Details {...detailsProps} onToggle={customToggle}>
        <Button as="summary">{open ? 'Open' : 'Closed'}</Button>
        Hello World
      </Details>
    )
  }}
</State>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2><inlineCode parentName="h2">{`useDetails`}</inlineCode>{` hook configuration options`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`defaultOpen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the initial open/closed state`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`closeOnOutsideClick`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets whether or not element will close when the user clicks outside of it`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ref`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`React ref`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`optional ref to pass down to Details component`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Values returned by the `}<inlineCode parentName="h3">{`useDetails`}</inlineCode>{` hook`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`open`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether or not Details is currently open`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`setOpen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`function`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Used to manually change the open state of the Details component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`getDetailsProps`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Contains an `}<inlineCode parentName="td">{`onToggle`}</inlineCode>{` function, the `}<inlineCode parentName="td">{`ref`}</inlineCode>{` to pass down to `}<inlineCode parentName="td">{`Details`}</inlineCode>{` and the `}<inlineCode parentName="td">{`open`}</inlineCode>{` attribute. In most cases, you won't need to interact with any of these values directly, but if you'd like to override any of these yourself you may.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      